angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MY_TRIP": {
    "DURATION": "for {hours} {hours, plural, one{hour} other{hours}}",
    "DELETE" : {
      "HEADER" : "Delete your trip",
      "CONTENT" : "Are you sure you want to delete this trip?",
      "LABEL" : "Cancel the creation of automatic trips in the future",
      "DELETE" : "Delete",
      "CANCEL" : "Cancel",
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/trips/my_trips/my_trip_list/my_trip.json
// module id = 425
// module chunks = 24